import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import axios from 'axios'
import { getCookie } from 'estimate_list/libs/cookie'
import { LOG_IN_REQUEST, LOG_IN_SUCCESS, LOG_IN_FAILURE } from '../reducers/user'

function logInAPI() {
    const url = '/front/v2/user/info'
    const auth_token = getCookie('auth_token')
    const config = {
        withCredentials: true,
        xsrfHeaderName: 'Authorization'
    }
    return axios.post(url, {auth_token}, config)
}

function* logIn() {
    try {
        const result = yield call(logInAPI)
        yield put({
            type: LOG_IN_SUCCESS,
            data: result.data,
        })
    } catch (e) {
        console.error(e)
        yield put({
            type: LOG_IN_FAILURE,
        })
    }
}

function* watchLogIn() {
    yield takeLatest(LOG_IN_REQUEST, logIn)
}

export default function* userSaga() {
    yield all([fork(watchLogIn)])
}



// WEBPACK FOOTER //
// ./src/estimate_list/sagas/user.js